import instance from "@/services/api";

export const tierFactFirstAPI = {
  async getResidents() {
    return await instance()
      .get("/tier/resident/read/")
      .then((res) => res?.data);
  },
  async getBlocks(resident_id) {
    return await instance()
      .get("/tier/block/read/", { params: { resident_id } })
      .then((res) => res?.data);
  },
  async getWorkGroups(block_id) {
    return await instance()
      .get("/tier/work_group/read/", { params: { block_id } })
      .then((res) => res?.data);
  },
  async getTimelineTasks(work_group_id) {
    return await instance()
      .get("/tier/timeline/task/read/", { params: { work_group_id } })
      .then((res) => res?.data);
  },
  async getPlanFact(work_group_id, date_from = null, date_to = null) {
    const params = { work_group_id };
    if (date_from) params.date_from = date_from;
    if (date_to) params.date_to = date_to;
    return await instance()
      .get("/tier/tier_fact_first/plan_fact/read/", { params })
      .then((res) => res?.data);
  },
  async getCalcDates(work_group_id, date_from = null, date_to = null) {
    const params = { work_group_id };
    if (date_from) params.date_from = date_from;
    if (date_to) params.date_to = date_to;
    return await instance()
      .get("/tier/tier_fact_first/calc_dates/read/", { params })
      .then((res) => res?.data);
  },
  async getLaborPlan(work_group_id) {
    return await instance()
      .get("/tier/labor_plan/read/", { params: { work_group_id } })
      .then((res) => res?.data);
  },
  async getReasons() {
    return await instance()
      .get("/tier/reason/read/")
      .then((res) => res?.data);
  },
  async saveFact(data) {
    return await instance()
      .post("/tier/tier_fact_first/fact/save/", data)
      .then((res) => res?.data);
  },
  async deleteFact(data) {
    return await instance()
      .post("/tier/tier_fact_first/fact/delete/", data)
      .then((res) => res?.data);
  },
  async saveLaborFact(data) {
    return await instance()
      .post("/tier/tier_fact_first/labor_fact/save/", data)
      .then((res) => res?.data);
  },
  async getTimelineReasons(work_group_id, date_start = null, date_end = null) {
    const params = { work_group_id };
    if (date_start) {
      params.date_start = date_start;
    }
    if (date_end) {
      params.date_end = date_end;
    }
    return await instance()
      .get("/tier/timeline/reasons/read/", { params })
      .then((res) => res?.data);
  },
  async recalcAll(work_group_id) {
    return await instance()
      .post("/tier/tier_fact_first/recalc/", { work_group_id })
      .then((res) => res?.data);
  },
};
